import { render } from "./PoppedProfile.vue?vue&type=template&id=0d799aa6"
import script from "./PoppedProfile.vue?vue&type=script&lang=js"
export * from "./PoppedProfile.vue?vue&type=script&lang=js"

import "./PoppedProfile.vue?vue&type=style&index=0&id=0d799aa6&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__